document.addEventListener('DOMContentLoaded', () => {

  /* ==========================================================
     ON THIS PAGE
  ========================================================== */

  const toc = document.getElementById('blog-pillar-toc');

  if (toc) {

    const headings = document.querySelectorAll(
      '.blog-pillar__main h1, .blog-pillar__main h2'
    );

    headings.forEach((heading) => {

      if (!heading.id) {
        heading.id = heading.textContent
          .trim()
          .toLowerCase()
          .replace(/[^\w\s-]/g, '')
          .replace(/\s+/g, '-');
      }

      const li = document.createElement('li');

      if (heading.tagName === 'H2') {
        li.classList.add('is-h2');
      }

      const a = document.createElement('a');

      a.href = `#${heading.id}`;

      if (heading.tagName === 'H1') {
        a.textContent = 'Introduction';
      } else {
        if (heading.dataset.tocTitle) {

  a.textContent = heading.dataset.tocTitle;

} else {

  const words = heading.textContent.trim().split(/\s+/);

  if (words.length > 6) {

    a.textContent = words.slice(0, 6).join(' ') + '...';

  } else {

    a.textContent = heading.textContent;

  }

}
      }

      a.addEventListener('click', function (e) {

        e.preventDefault();

        const target = document.getElementById(heading.id);

        if (target) {
 const header = document.querySelector('.main-section-header');

  const headerHeight = header
    ? header.getBoundingClientRect().height
    : 220;

  const extraSpacing = 135;

  const elementPosition =
    target.getBoundingClientRect().top + window.pageYOffset;

  window.scrollTo({
    top: elementPosition - headerHeight - extraSpacing,
    behavior: 'smooth'
  });

        }

      });

      li.appendChild(a);
      toc.appendChild(li);

    });

  }

  /* ==========================================================
     FEATURED PRODUCTS
  ========================================================== */

  document.querySelectorAll('.blog-pillar-featured').forEach((featured) => {

    const track = featured.querySelector('.blog-pillar-featured__track');
    const pages = featured.querySelectorAll('.blog-pillar-featured__page');

    if (!track || pages.length === 0) return;

    const prev = featured.querySelector('.blog-pillar-featured__prev');
    const next = featured.querySelector('.blog-pillar-featured__next');
    const viewport = featured.querySelector('.blog-pillar-featured__viewport');

    let currentPage = 0;

    function updateCarousel() {

      const pageHeight = pages[0].offsetHeight;

      viewport.style.height = `${pageHeight}px`;

      track.style.transform =
        `translateY(-${currentPage * pageHeight}px)`;

    }

    function nextPage() {

      currentPage = (currentPage + 1) % pages.length;

      updateCarousel();

    }

    function prevPage() {

      currentPage =
        (currentPage - 1 + pages.length) % pages.length;

      updateCarousel();

    }

    if (next) next.addEventListener('click', nextPage);
    if (prev) prev.addEventListener('click', prevPage);

    let autoplay = setInterval(nextPage, 5000);

    featured.addEventListener('mouseenter', () => {
      clearInterval(autoplay);
    });

    featured.addEventListener('mouseleave', () => {
      autoplay = setInterval(nextPage, 5000);
    });

    window.addEventListener('resize', updateCarousel);

    updateCarousel();

  });

  /* ==========================================================
     MOBILE DRAWER
  ========================================================== */

  const drawer = document.querySelector('.blog-pillar-mobile-products');

  if (drawer) {

    const openBtn = drawer.querySelector(
      '.blog-pillar-mobile-products__toggle'
    );

    const closeBtn = drawer.querySelector(
      '.blog-pillar-mobile-products__close'
    );

    openBtn.addEventListener('click', () => {

      drawer.classList.add('is-open');

      document.body.style.overflow = 'hidden';

    });

    closeBtn.addEventListener('click', () => {

      drawer.classList.remove('is-open');

      document.body.style.overflow = '';

    });

  }
/* ==========================================================
   RELATED ARTICLES LOAD MORE
========================================================== */

const loadMoreBtn = document.querySelector('.js-related-load-more');

if (loadMoreBtn) {

  loadMoreBtn.addEventListener('click', () => {

    const hiddenCards = document.querySelectorAll(
      '.js-related-item.is-hidden'
    );

    let revealed = 0;

    hiddenCards.forEach(card => {

      if (revealed < 6) {

        card.classList.remove('is-hidden');

        revealed++;

      }

    });

    if (
      document.querySelectorAll('.js-related-item.is-hidden').length === 0
    ) {

      loadMoreBtn.style.display = 'none';

    }

  });

}

});